import React, { useEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { Heading, Text } from '../../components/ui'
import { PermissionGuard } from '../../components/PermissionGuard'
import { modulesService } from '../../services/modules'

export const MODULE_NAME = 'fluxograma'

const Fluxograma: React.FC = () => {
  const location = useLocation()
  const [moduleTitle, setModuleTitle] = useState('Fluxograma')
  const [moduleDescription, setModuleDescription] = useState(
    'Criação e gestão de fluxogramas compartilhados'
  )

  const isEditorRoute =
    location.pathname.includes('/novo') ||
    /\/qualidade\/fluxograma\/[^/]+$/.test(location.pathname)

  useEffect(() => {
    const loadModuleInfo = async () => {
      try {
        const result = await modulesService.getByName(MODULE_NAME)
        if (result.success && result.data) {
          if (result.data.display_name) {
            setModuleTitle(result.data.display_name)
          }
          if (result.data.description) {
            setModuleDescription(result.data.description)
          }
        }
      } catch (error) {
        console.error('Erro ao buscar informações do módulo:', error)
      }
    }

    void loadModuleInfo()
  }, [])

  return (
    <div className="flex-1 flex flex-col overflow-x-hidden overflow-y-hidden min-w-0">
      <PermissionGuard
          moduleName={MODULE_NAME}
          permissionType="show"
          fallback={
            <div className="flex-1 flex items-center justify-center">
              <div className="text-center">
                <Text size="xl" className="text-gray-500 dark:text-gray-400 mb-2">
                  Acesso Negado
                </Text>
                <Text size="sm" color="muted">
                  Você não tem permissão para acessar esta página.
                </Text>
              </div>
            </div>
          }
        >
          <div className="h-full flex flex-col min-h-0">
            {!isEditorRoute && (
              <div className="p-6 border-b border-gray-200 dark:border-gray-700 shrink-0">
                <Heading as="h1" size="3xl" className="text-gray-900 dark:text-white">
                  {moduleTitle}
                </Heading>
                <Text size="sm" color="muted" className="mt-2">
                  {moduleDescription}
                </Text>
              </div>
            )}
            <div className="flex-1 min-h-0 flex flex-col overflow-hidden">
              <Outlet context={{ moduleTitle }} />
            </div>
          </div>
        </PermissionGuard>
    </div>
  )
}

export default Fluxograma
